"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualPolicyInfo = void 0;
class AnnualPolicyInfo {
}
exports.AnnualPolicyInfo = AnnualPolicyInfo;
//# sourceMappingURL=AnnualPolicyInfo.js.map